import { ArrowRightIcon } from '@fingertip/icons'
import { observer } from 'mobx-react-lite'
import { useCallback, useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { bookerProgression, BookingStage } from '@/lib/stores/booker-store'
import { RootStoreContext } from '@/lib/stores/root-store'
import { cn } from '@/lib/utils'

import { Button } from '../../../ui/button'

type Props = {
  stage: BookingStage
  className?: string
}

export const BookerNext = observer(({ stage, className }: Props) => {
  const { t } = useTranslation()
  const {
    bookerStore: {
      setStage,
      selectedDate,
      selectedTimeslot,
      selectedUserId,
      bookingId,
      paymentCollectionType,
      bookingItemsData,
      memberOptionsData,
    },
  } = useContext(RootStoreContext)

  const enabled = useMemo(() => {
    if (stage) {
      const logic = bookerProgression[stage]
      return logic.next({
        selectedDate,
        selectedTimeslot,
        bookingId,
        paymentCollectionType,
        bookingItemsData,
        selectedUserId,
        memberOptionsData,
      })
    }
    return false
  }, [
    bookingId,
    bookingItemsData,
    memberOptionsData,
    paymentCollectionType,
    selectedDate,
    selectedTimeslot,
    selectedUserId,
    stage,
  ])

  const handleNav = useCallback(() => {
    if (stage) {
      setStage(stage)
    }
  }, [setStage, stage])

  return (
    <Button
      size="default"
      onClick={handleNav}
      disabled={!enabled}
      type="button"
      className={cn('w-full', className)}
    >
      <span className="mr-2">{t('next')}</span>
      <ArrowRightIcon className="size-4" />
    </Button>
  )
})
